export default "__VITE_ASSET__B_kcmH_n__"